import React from 'react';
import styled from 'styled-components';
import { AccordionSummary } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

const Wrapper = styled(AccordionSummary)`
  position: relative;
  padding: 1.5rem 2.5rem !important;
  min-height: 48px !important;
  cursor: pointer;

  &.expanded, &:hover {
    background-color: #232323;
    
    h2 {
      color: #e5e5e5;
    }

    .material-icons-outlined {
      color: #e5e5e5;
    }
  }

  .MuiAccordionSummary-content {
    margin: 0 !important;
    align-items: center;

    & > svg:first-child {
      margin-right: 24px;
    }

    summary {
      padding: 0;
    }
  }

  .MuiButtonBase-root {
    padding: 0;
  }


  h2 {
    flex: 1;
    font-size: 14px;
    font-weight: 600;
    color: ${({ theme }) => theme.textColor.secondary};
    margin-left: 30px;
  }

  .material-icons-outlined {
    color: ${({ theme }) => theme.textColor.secondary};
  }

  &:focus {
    outline: 0;
  }

  &:hover {
    background-color: #232323;
  }
`

const Summary = ({ icon, appendIcon, label, editable, expanded, withExpandIcon, ...props }) => {
  return (
    <Wrapper {...props} expandIcon={withExpandIcon ? <ExpandMore fontSize="large" /> : null} className={expanded ? 'expanded' :  ''}>
      {icon && <span className="material-icons-outlined">{icon}</span>}
      <h2>{label}</h2>
      {editable && expanded && appendIcon} 
    </Wrapper>
  )
}

export default Summary;